<section class="tile-flat site-card">
  <header class="tile-flat__header">
    <div class="site-card__head">
      <div class="site-card__head-left">
        <img src="/assets/images/integrations/ilias.png" alt="" class="site-card__logo" />
        <div class="site-card__title">
          <h5 class="site-card__name">{{ registration.display_name }}</h5>
          <span class="site-card__identity">
            <span class="site-card__url">{{ issuerHost() }}</span>
            <!-- Die Version gehoert zur Instanz, nicht zum Verbindungszustand:
                 sie steht deshalb hier unter dem Namen und nicht rechts neben
                 der Zustandsmarke. -->
            <span *ngIf="iliasVersion" class="state-chip">ILIAS {{ iliasVersion }}</span>
          </span>
        </div>
      </div>
      <div class="site-card__head-right">
        <!-- Zustandsmarke wie bei Moodle: pausiert / verbunden / nie gesehen.
             Der Admin sieht vor dem ersten Klick, ob die Anbindung lebt. -->
        <span
          class="status-pill"
          [class.is-online]="isConnected()"
          [class.is-paused]="!!registration.disabled_at"
        >
          <span class="status-pill__dot"></span>
          <span>
            {{
              registration.disabled_at
                ? ('pages.tutors.placements.lms.paused' | translate)
                : isConnected()
                  ? ('pages.tutors.placements.lms.online' | translate)
                  : ('pages.tutors.placements.lms.notSeen' | translate)
            }}
          </span>
        </span>

        <span class="site-card__count" [class.is-loading]="loading || coursesLoading || syncing">
          <ng-container *ngIf="loading || coursesLoading || syncing; else placementCount">
            <nb-icon icon="sync-outline" class="spin"></nb-icon>
            {{ 'pages.tutors.placements.ilias.syncingData' | translate }}
          </ng-container>
          <ng-template #placementCount>
            {{ placements.length }} {{ 'pages.tutors.placements.lti.count' | translate }}
          </ng-template>
        </span>

        <button
          nbButton
          size="small"
          status="primary"
          outline
          class="secondary-action-button"
          [disabled]="loading || coursesLoading || syncing"
          (click)="reloadAll()"
          [attr.aria-label]="'buttons.refresh' | translate"
        >
          <nb-icon
            [icon]="loading || coursesLoading || syncing ? 'sync-outline' : 'refresh-outline'"
            [class.spin]="loading || coursesLoading || syncing"
          ></nb-icon>
          {{ (syncing ? 'pages.tutors.placements.ilias.syncingData' : 'buttons.refresh') | translate }}
        </button>
      </div>
    </div>
  </header>

  <!-- Der technische Zugang ist hierher gewandert: er gehoert zum
       Datenabgleich, nicht zur Frage, welcher Agent wo antwortet. -->
  <p class="soap-pointer">
    <nb-icon icon="info-outline"></nb-icon>
    <span>
      {{ 'pages.tutors.placements.ilias.soapMoved' | translate }}
      <a href="javascript:void(0)" (click)="goToIliasOverview()">
        {{ 'pages.tutors.placements.ilias.soapMovedLink' | translate }}
      </a>
    </span>
  </p>

  <!-- Werkzeugleiste wie in der Moodle-Karte: Suche, drei Filter, Zählung. -->
  <div *ngIf="!coursesLoading && iliasCourses.length > 0" class="site-card__filter">
    <nb-form-field>
      <nb-icon nbPrefix icon="search-outline"></nb-icon>
      <input
        nbInput
        fieldSize="small"
        type="text"
        [(ngModel)]="search"
        [placeholder]="'pages.tutors.placements.ilias.searchPlaceholder' | translate"
      />
      <nb-icon
        *ngIf="search"
        nbSuffix
        icon="close-outline"
        class="site-card__clear-filter"
        (click)="clearSearch()"
        [attr.title]="'pages.tutors.placements.lms.clearFilter' | translate"
      ></nb-icon>
    </nb-form-field>

    <nb-select size="small" [(selected)]="categoryFilter">
      <nb-option value="">{{ 'pages.tutors.placements.ilias.filter.allCategories' | translate }}</nb-option>
      <nb-option *ngFor="let cat of categories" [value]="cat">{{ cat }}</nb-option>
    </nb-select>

    <nb-select size="small" [(selected)]="placementFilter">
      <nb-option value="any">{{ 'pages.tutors.placements.ilias.filter.anyPlacement' | translate }}</nb-option>
      <nb-option value="placed">{{ 'pages.tutors.placements.ilias.filter.placed' | translate }}</nb-option>
      <nb-option value="unplaced">{{ 'pages.tutors.placements.ilias.filter.unplaced' | translate }}</nb-option>
    </nb-select>

    <nb-select size="small" [(selected)]="syncFilter">
      <nb-option value="any">{{ 'pages.tutors.placements.ilias.filter.anySync' | translate }}</nb-option>
      <nb-option value="enabled">{{ 'pages.tutors.placements.ilias.filter.syncEnabled' | translate }}</nb-option>
      <nb-option value="disabled">{{ 'pages.tutors.placements.ilias.filter.syncDisabled' | translate }}</nb-option>
    </nb-select>

    <span class="site-card__count">
      {{ 'pages.tutors.placements.ilias.rowCount' | translate: { shown: filteredRows.length, total: iliasCourses.length, placed: placedCount } }}
    </span>

    <app-pagination
      *ngIf="filteredRows.length > 0"
      class="site-card__pagination"
      [totalItems]="filteredRows.length"
      [itemsPerPage]="pageSize"
      [currentPage]="page"
      [pageSizeOptions]="pageSizeOptions"
      (pageChanged)="onPageChange($event)"
      (itemsPerPageChange)="onPageSizeChange($event)"
    ></app-pagination>
  </div>

  <!-- Sammelaktionen, sichtbar sobald etwas gewählt ist — dieselbe Stelle und
       dieselbe Reihenfolge wie bei Moodle. -->
  <div *ngIf="selected.size > 0" class="site-card__bulkbar">
    <span class="site-card__bulk-count">
      {{ 'pages.tutors.placements.ilias.bulk.selecting' | translate: { count: selected.size } }}
    </span>

    <nb-select
      size="small"
      [(selected)]="bulkAgentId"
      [placeholder]="'pages.tutors.placements.ilias.bulk.agentPlaceholder' | translate"
    >
      <nb-option *ngFor="let t of tutors" [value]="t.id">{{ tutorName(t.id) }}</nb-option>
    </nb-select>

    <button
      nbButton
      size="small"
      status="primary"
      [disabled]="!bulkAgentId || bulkBusy"
      (click)="applyBulkAgent()"
    >
      {{ 'pages.tutors.placements.ilias.bulk.place' | translate }}
    </button>

    <button
      nbButton
      size="small"
      status="basic"
      [disabled]="bulkBusy"
      [nbTooltip]="'pages.tutors.placements.ilias.bulk.syncTooltip' | translate"
      (click)="applyBulkContentSync(true)"
    >
      <nb-icon icon="cloud-download-outline"></nb-icon>
      {{ 'pages.tutors.placements.ilias.bulk.sync' | translate }}
    </button>

    <button
      nbButton
      size="small"
      status="basic"
      class="btn-caution"
      [disabled]="bulkBusy"
      [nbTooltip]="'pages.tutors.placements.ilias.bulk.unsyncTooltip' | translate"
      (click)="applyBulkContentSync(false)"
    >
      {{ 'pages.tutors.placements.ilias.bulk.unsync' | translate }}
    </button>

    <button nbButton ghost size="small" status="basic" (click)="selected.clear()">
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>

  <div *ngIf="loading || coursesLoading" class="site-card__loading">
    <nb-spinner status="basic"></nb-spinner>
  </div>

  <!-- Ohne abgeglichene Kurse ist die Tabelle nicht leer, sondern unmöglich —
       der Hinweis nennt deshalb den Abgleich, nicht die Platzierung. -->
  <div *ngIf="!coursesLoading && iliasCourses.length === 0" class="site-card__empty">
    <p>{{ 'pages.tutors.placements.ilias.noCourses' | translate }}</p>
  </div>

  <div
    *ngIf="!loading && !coursesLoading && iliasCourses.length > 0"
    class="site-card__table-scroll"
    appScrollOverflow
  >
  <table class="site-card__table">
    <colgroup>
      <col class="col-select" />
      <col class="col-course" />
      <col class="col-tutor" />
      <col class="col-course-sync" />
      <col class="col-structure-parse" />
      <col class="col-sync-status" />
      <col class="col-kb" />
      <col class="col-dozent" />
      <col class="col-activities" />
      <col class="col-preview" />
      <col class="col-actions" />
    </colgroup>
    <thead>
      <tr>
        <th class="cell-select">
          <nb-checkbox
            [checked]="allSelected"
            (checkedChange)="toggleSelectAll($event)"
            [attr.aria-label]="'pages.tutors.placements.ilias.col.selectAll' | translate"
          ></nb-checkbox>
        </th>
        <th
          class="is-sortable"
          [nbTooltip]="'pages.tutors.placements.ilias.col.courseTooltip' | translate"
          nbTooltipPlacement="top"
        >
          <button
            type="button"
            class="sortable-header"
            (click)="toggleCourseSort()"
            [attr.aria-label]="'pages.tutors.placements.ilias.col.courseSort' | translate"
          >
            <span>{{ 'pages.tutors.placements.ilias.col.course' | translate }}</span>
            <nb-icon
              [icon]="courseSortDirection === 'asc' ? 'arrow-upward-outline' : 'arrow-downward-outline'"
              class="sort-icon"
            ></nb-icon>
          </button>
        </th>
        <th [nbTooltip]="'pages.tutors.placements.lti.col.agentTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.lti.col.agent' | translate }}
        </th>
        <th class="cell-course-sync" alAnchor="placements.course-sync" [nbTooltip]="'pages.tutors.placements.ilias.col.contentTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.ilias.col.content' | translate }}
        </th>
        <th class="cell-structure-parse" [nbTooltip]="'pages.tutors.placements.ilias.col.structureTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.ilias.col.structure' | translate }}
        </th>
        <th class="cell-sync-status" [nbTooltip]="'pages.tutors.placements.ilias.col.statusTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.ilias.col.status' | translate }}
        </th>
        <th [nbTooltip]="'pages.tutors.placements.lms.col.kbTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.lms.col.kb' | translate }}
        </th>
        <th [nbTooltip]="'pages.tutors.placements.lms.col.dozentTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.lms.col.dozent' | translate }}
        </th>
        <th class="cell-activities" [nbTooltip]="'pages.tutors.placements.ilias.col.objectsTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.ilias.col.objects' | translate }}
        </th>
        <th class="cell-preview" [nbTooltip]="'pages.tutors.placements.ilias.col.previewTooltip' | translate" nbTooltipPlacement="top">
          {{ 'pages.tutors.placements.lms.col.preview' | translate }}
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of pagedRows; trackBy: trackRow"
        [class.is-placed]="!!row.placement"
        [class.is-selected]="isSelected(row)"
      >
        <td class="cell-select">
          <nb-checkbox
            [checked]="isSelected(row)"
            (checkedChange)="toggleSelected(row, $event)"
          ></nb-checkbox>
        </td>

        <!-- Einzeilig; bei Überlänge läuft der Titel bei Mouseover durch. -->
        <td class="cell-course" appMarqueeOnHover>
          <div class="site-card__course-name marquee">{{ row.course.title }}</div>
          <div class="site-card__course-meta">
            <span class="muted">ref_id {{ row.course.external_id }}</span>
            <ng-container *ngIf="row.course.path">
              <span class="muted">·</span>
              <span class="muted">{{ row.course.path }}</span>
            </ng-container>
          </div>
        </td>

        <td class="cell-tutor">
          <!-- Bauform der Moodle-Zelle: Auswahl mit internem Namen und
               Anzeigenamen als Anhängsel. Sie schreibt in den Puffer der
               Zeile — gültig wird die Änderung erst mit „Speichern". -->
          <nb-select
            *ngIf="rowHasAgentPlacement(row); else noTutor"
            [(ngModel)]="row.edit.botId"
            [placeholder]="'pages.tutors.placements.ilias.chooseAgent' | translate"
            [optionsWidth]="300"
            fullWidth
            size="small"
          >
            <nb-select-label>
              <span class="tutor-select-label">
                <span
                  class="tutor-select-label__name"
                  appTruncateTooltip
                  [appTruncateTooltip]="tutorName(row.edit.botId)"
                  nbTooltip
                  nbTooltipPlacement="top"
                >{{ tutorName(row.edit.botId) || ('pages.tutors.placements.ilias.noAgentOption' | translate) }}</span>
                <span *ngIf="tutorVisual(row.edit.botId) as visual" class="tutor-select-label__visual">
                  {{ visual }}
                </span>
              </span>
            </nb-select-label>
            <nb-option [value]="null">{{ 'pages.tutors.placements.ilias.noAgentOption' | translate }}</nb-option>
            <nb-option *ngFor="let t of tutors" [value]="t.id">
              <span class="tutor-option">
                <span
                  class="tutor-option__name"
                  appTruncateTooltip
                  [appTruncateTooltip]="t.name"
                  nbTooltip
                  nbTooltipPlacement="top"
                >{{ t.name }}</span>
                <span *ngIf="tutorVisual(t.id) as visual" class="tutor-option__visual">{{ visual }}</span>
              </span>
            </nb-option>
          </nb-select>
          <!-- Wo der Agent am Ende auftaucht. Dieselbe Zeile wirkt je nach
               Kanal voellig verschieden: ueber das Plugin liegt der Tutor auf
               JEDER Seite des Kurses, ueber LTI sitzt er im Kasten eines
               Objekts, das jemand im Kurs anlegen muss. Ohne diesen Hinweis
               steht in beiden Faellen nur ein Agentenname, und niemand sieht
               den Unterschied. -->
          <p *ngIf="rowHasAgentPlacement(row)" class="cell-tutor__effect">
            {{ placementEffectKey(row) | translate }}
            <span *ngIf="hasExtraActivityPlacements(row)">
              {{ 'pages.tutors.placements.ilias.effect.plusActivities'
                 | translate: { count: row.activityPlacements.length } }}
            </span>
          </p>
          <ng-template #noTutor>
            <!-- Ein Agent im LTI-Objekt ist ein Agent — nur eben nicht auf
                 den Kursseiten. „—" allein hat diesen Kurs als unbesetzt
                 ausgegeben und den Grund verschwiegen. -->
            <ng-container *ngIf="hasOnlyActivityPlacements(row); else reallyNoTutor">
              <span class="cell-tutor__activity-only">
                {{ 'pages.tutors.placements.ilias.effect.activityOnly'
                   | translate: { count: row.activityPlacements.length } }}
              </span>
              <p *ngIf="pluginPlaces" class="cell-tutor__effect">
                {{ 'pages.tutors.placements.ilias.effect.activityOnlyPluginHint' | translate }}
              </p>
            </ng-container>
            <ng-template #reallyNoTutor><span class="muted">—</span></ng-template>
          </ng-template>
        </td>

        <td class="cell-course-sync">
          <!-- Der Schalter greift sofort, nicht über „Speichern" — wie bei
               Moodle. Er bleibt beim Laufen im Baum, der Kreisel liegt als
               kleine Marke in seiner Ecke; ihn wegzublenden nahm der
               Umschaltbewegung die Animation. -->
          <span
            class="course-sync-inline"
            [nbTooltip]="(courseSyncAvailable()
              ? 'pages.tutors.placements.ilias.col.contentTooltip'
              : 'pages.tutors.placements.ilias.contentNeedsActiveConnection') | translate"
            nbTooltipPlacement="top"
          >
            <span class="course-sync-toggle-slot">
              <nb-toggle
                [checked]="row.edit.courseSyncEnabled"
                [disabled]="!courseSyncAvailable() || row.savingSync"
                (checkedChange)="onCourseSyncToggle(row, $event)"
              ></nb-toggle>
              <span
                class="course-sync-spinner course-sync-spinner--overlay"
                *ngIf="row.savingSync"
                aria-hidden="true"
              ></span>
            </span>
          </span>
        </td>

        <td class="cell-structure-parse">
          <span
            class="course-sync-inline"
            [nbTooltip]="(structureParseAvailable(row)
              ? 'pages.tutors.placements.ilias.col.structureTooltip'
              : 'pages.tutors.placements.ilias.structureNeedsContentTooltip') | translate"
            nbTooltipPlacement="top"
          >
            <span class="course-sync-toggle-slot">
              <nb-toggle
                [checked]="row.edit.structureParseEnabled"
                [disabled]="!structureParseAvailable(row) || row.savingStructureParse"
                (checkedChange)="onStructureParseToggle(row, $event)"
              ></nb-toggle>
              <span
                class="course-sync-spinner course-sync-spinner--overlay"
                *ngIf="row.savingStructureParse"
                aria-hidden="true"
              ></span>
            </span>
          </span>
        </td>

        <td class="cell-sync-status">
          <span
            class="sync-status-chip"
            [ngClass]="rowStatusClass(row)"
            [nbTooltip]="rowStatusKey(row) + 'Tooltip' | translate"
            nbTooltipPlacement="top"
          >
            <span class="sync-status-chip__dot"></span>
            <span>{{ rowStatusKey(row) | translate }}</span>
          </span>
        </td>

        <td class="cell-kb">
          <nb-select
            *ngIf="rowHasAgentPlacement(row); else noKb"
            multiple
            [(ngModel)]="row.edit.kbIds"
            [placeholder]="'pages.tutors.placements.kb.kbPlaceholder' | translate"
            [optionsWidth]="280"
            fullWidth
            size="small"
          >
            <nb-option *ngFor="let ds of dataSources" [value]="ds.id">
              {{ ds | knowledgeSourceName | async }}
            </nb-option>
          </nb-select>
          <ng-template #noKb>
            <span class="muted">—</span>
          </ng-template>
        </td>

        <td class="cell-dozent">
          <!-- Schalter und Auswahl — dieselbe Bauform wie in der Moodle-Karte:
               erst einschalten, dann den Twin wählen. -->
          <ng-container *ngIf="rowHasAgentPlacement(row); else noDozent">
            <div class="dozent-control has-select">
              <span
                class="dozent-control__toggle"
                [nbTooltip]="'pages.tutors.placements.lms.dozentToggleDisabledHint' | translate"
                [nbTooltipDisabled]="isDozentCompatible(row.edit.botId)"
                nbTooltipPlacement="top"
              >
                <nb-toggle
                  [checked]="row.edit.dozentEnabled"
                  [disabled]="!isDozentCompatible(row.edit.botId)"
                  (checkedChange)="row.edit.dozentEnabled = $event; !$event && (row.edit.dozentBotId = null)"
                ></nb-toggle>
              </span>
              <nb-select
                [(ngModel)]="row.edit.dozentBotId"
                [disabled]="!row.edit.dozentEnabled || !isDozentCompatible(row.edit.botId)"
                [placeholder]="'pages.tutors.placements.kb.dozentPlaceholder' | translate"
                [optionsWidth]="260"
                fullWidth
                size="small"
              >
                <nb-select-label>
                  <span
                    *ngIf="dozentName(row.edit.dozentBotId) as dozentLabel"
                    class="dozent-select-label"
                  >
                    <span
                      class="dozent-select-label__name"
                      appTruncateTooltip
                      nbTooltip
                      nbTooltipPlacement="top"
                    >{{ dozentLabel }}</span>
                  </span>
                </nb-select-label>
                <nb-option *ngFor="let d of dozentBots" [value]="d.id">
                  <span class="dozent-option-label">
                    <span
                      class="dozent-option-label__name"
                      appTruncateTooltip
                      nbTooltip
                      nbTooltipPlacement="top"
                    >{{ d.name }}</span>
                  </span>
                </nb-option>
              </nb-select>
            </div>
          </ng-container>
          <ng-template #noDozent>
            <span class="muted">—</span>
          </ng-template>
        </td>

        <td class="cell-activities">
          <!-- Die Zahl der abgeglichenen Objekte, der Tooltip schlüsselt sie
               nach Art auf: „4 Dateien · 1 Test". -->
          <span
            class="activity-count-pill"
            [nbTooltip]="objectTypeSummary(row)"
            nbTooltipPlacement="top"
          >{{ objectCount(row) }}</span>
        </td>

        <td class="cell-preview">
          <!-- Nach dem **gespeicherten** Agenten, nicht nach dem Puffer: die
               Vorschau startet eine echte Sitzung auf der Platzierung. Mit
               `row.edit.botId` erschien der Knopf schon bei ungespeicherter
               Auswahl und antwortete dann mit „kein Agent". -->
          <button
            *ngIf="row.placement?.bot_id; else noPreview"
            type="button"
            class="al-icon-button al-icon-button--primary site-card__preview-button"
            [class.is-active]="isPreviewActive(row)"
            [nbTooltip]="(isPreviewActive(row)
              ? 'pages.tutors.placements.ilias.previewStop'
              : 'pages.tutors.placements.ilias.previewStart') | translate"
            nbTooltipPlacement="top"
            [attr.aria-label]="(isPreviewActive(row)
              ? 'pages.tutors.placements.ilias.previewStop'
              : 'pages.tutors.placements.ilias.previewStart') | translate"
            (click)="previewPlacement(row, $event)"
          >
            <nb-icon [icon]="isPreviewActive(row) ? 'stop-circle-outline' : 'play-circle-outline'"></nb-icon>
          </button>
          <ng-template #noPreview><span class="muted">—</span></ng-template>
        </td>

        <td class="cell-actions">
          <div class="site-card__actions-wrap">
            <!-- Platzierte Zeile: „Speichern" erscheint erst, wenn sich im
                 Puffer etwas geändert hat — kein dauerhaft grauer Knopf.
                 Ohne Platzierung steht dort der Platzieren-Knopf — genau wie
                 bei Moodle. -->
            <ng-container *ngIf="rowHasAgentPlacement(row); else placeBtn">
              <button
                *ngIf="isDirty(row) || row.saving"
                type="button"
                nbButton
                size="small"
                status="primary"
                [disabled]="row.saving"
                (click)="saveRow(row)"
              >
                <nb-icon *ngIf="row.saving" icon="loader-outline" class="spin"></nb-icon>
                {{ 'pages.tutors.placements.save' | translate }}
              </button>
            </ng-container>

            <ng-template #placeBtn>
              <button
                type="button"
                nbButton
                size="small"
                status="primary"
                outline
                class="secondary-action-button"
                (click)="openCreateFor(row)"
              >
                {{ 'pages.tutors.placements.lms.placeAction' | translate }}
              </button>
            </ng-template>

            <!-- Nur mit Einträgen: `NbContextMenuDirective` wirft bei einer
                 leeren Liste. -->
            <button
              *ngIf="rowMenuItems(row).length > 0"
              type="button"
              class="al-icon-button site-card__menu-button"
              [nbContextMenu]="rowMenuItems(row)"
              [nbContextMenuTag]="rowMenuTag(row)"
              nbContextMenuTrigger="click"
              [attr.aria-label]="'pages.tutors.placements.ilias.rowActions.openMenu' | translate"
            >
              <nb-icon icon="more-vertical-outline"></nb-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
</section>
